/**
 * TanStack Query singleton used by main.tsx (create) and app.tsx (provide).
 * Keeping the instance here breaks the main ↔ app import cycle that would
 * otherwise form if app.tsx imported the client from main.tsx.
 */
import { QueryClient } from '@tanstack/react-query';

import type { ApiError } from '@optum/api-client/client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Short stale time — admin ops want fresh data but not every request.
      staleTime: 10_000,
      // Don't retry on 401 — caller needs to redirect to /login, not spin.
      retry: (failureCount, err) => {
        const status = (err as ApiError | undefined)?.status;
        return status !== 401 && failureCount < 2;
      },
    },
  },
});
